
import { Route } from '@/app/router'

const AlternativeModels = () => import('./index.vue')

const AlternativeModelsProps = ['page', 'perPage']

export default [
	new Route('/alternative-models/:alternativeModelId?', AlternativeModels)
		.as('Dashboard:AlternativeModels')
		.permissions(['VIEW_VEHICLES'])
		.props(AlternativeModelsProps)
]
